import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AuthPromptModal = ({ isOpen, onClose, action = 'save' }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const actionTexts = {
    save: {
      title: 'Save Your Favourites',
      description: 'Create an account to save listings and never lose track of your favourite practitioners and events.',
      icon: 'Heart'
    },
    book: {
      title: 'Book Your Session',
      description: 'Sign in to book sessions and manage your wellness journey with trusted practitioners.',
      icon: 'Calendar'
    },
    contact: {
      title: 'Contact Practitioners',
      description: 'Create an account to message practitioners directly and get personalised recommendations.',
      icon: 'MessageCircle'
    }
  };

  const currentAction = actionTexts?.[action] || actionTexts?.save;

  const handleSignIn = () => {
    onClose();
    navigate('/login');
  };

  const handleSignUp = () => {
    onClose();
    navigate('/register');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-md bg-popover rounded-lg shadow-organic-lg animate-slide-in">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name={currentAction?.icon} size={20} className="text-primary" />
              </div>
              <div>
                <h2 className="text-xl font-heading font-semibold text-foreground">
                  {currentAction?.title}
                </h2>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-gentle"
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          {/* Content */}
          <div className="mb-8">
            <p className="text-muted-foreground font-body leading-relaxed">
              {currentAction?.description}
            </p>
          </div>

          {/* Benefits */}
          <div className="space-y-3 mb-8">
            <div className="flex items-center space-x-3">
              <div className="w-5 h-5 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Check" size={12} className="text-success" />
              </div>
              <span className="text-sm text-foreground font-body">
                Save your favourite practitioners and events
              </span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-5 h-5 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Check" size={12} className="text-success" />
              </div>
              <span className="text-sm text-foreground font-body">
                Get personalised recommendations
              </span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-5 h-5 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Check" size={12} className="text-success" />
              </div>
              <span className="text-sm text-foreground font-body">
                Book sessions and manage your wellness journey
              </span>
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <Button
              variant="default"
              fullWidth
              onClick={handleSignUp}
              iconName="UserPlus"
              iconPosition="left"
            >
              Create Free Account
            </Button>

            <Button
              variant="outline"
              fullWidth
              onClick={handleSignIn}
              iconName="LogIn"
              iconPosition="left"
            >
              Sign In
            </Button>
          </div>

          {/* Footer */}
          <div className="mt-6 pt-6 border-t border-border text-center">
            <p className="text-xs text-muted-foreground font-body">
              Free to join • No spam • Cancel anytime
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPromptModal;
